document.addEventListener("input", (e) => {
  if (e.target.classList.contains("x-autoresize")) {
    e.target.parentNode.dataset.replicatedValue = e.target.value;
  }
});
